import React, {Component} from 'react';
import swal from 'sweetalert';
import { Card, CardContent } from '@material-ui/core';
import { LineChart, CartesianGrid, XAxis, YAxis, Legend, Tooltip, Line, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar } from 'recharts';
import $, { data } from 'jquery';
import {
    dashboardDaylyDonations, dashboardUnitComponentType
} from '../../libs/services';


const Config = require('../../config');
//import {makeStyles, Card } from '@material-ui';

class Graphics extends Component{
    
    constructor(props){
        super(props);

        this.state = {
            daily_donations: [],
            units_by_component_type: [],
            colorArray: ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
        }
    }

    async componentDidMount(){
        var daily = this.props.graphics.findIndex(obj => obj.graph_key === 'LINE_DAILY_DONATIONS');

        if(daily !== -1){
            var response = await dashboardDaylyDonations();

            if(response !== undefined){
                response.map((r)=>{
                    r.Aceptados = r.total_accepted;
                    r.Rechazados = r.total_rejected;
                    r.Total = r.total_accepted + r.total_rejected;
                });
                this.setState({daily_donations: response});
            }
            
        }

        var pie = this.props.graphics.findIndex(obj => obj.graph_key === 'PIE_UNIT_COMPONENTS');
        if(pie !== -1){

            var response = await dashboardUnitComponentType();

            if(response !== undefined){
                this.setState({units_by_component_type:response});
            }            
        }

    }

    render(){
        return(
            <div className="col-xs-12">
                
                <div className="col-xs-12 form-group daily-don" style={{marginTop:'1%'}}>
                    {this.state.daily_donations.length > 0 ?
                        <Card variant="outlined">
                            <CardContent className="">                           
                                <div className="col-xs-12" style={{textAlign:'center'}}>
                                    <h3>Donaciones</h3>
                                </div>
                                <div className="col-xs-12">
                                    <BarChart
                                        width={$('.daily-don').width() - 100}
                                        height={300}
                                        data={this.state.daily_donations}
                                        margin={{top:20, right:50, left:20, bottom:5}}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="day" padding={{left:20, right:30}} />
                                        <YAxis />
                                        <Legend />
                                        <Tooltip />
                                        <Bar dataKey="Aceptados" stackId="stack" fill="#2A83CE" />
                                        <Bar dataKey="Rechazados" stackId="stack" fill="#CE3E2A" />
                                    </BarChart>
                                </div>
                                
                            </CardContent>
                            
                        </Card>
                    :null}
                </div>

                <div className="col-xs-12 form-group">
                    <div className="col-xs-12 col-sm-4 pie-graph">
                        {this.state.units_by_component_type.length > 0 &&
                            <Card variant="outlined">
                                <CardContent className="">                           
                                    <div className="col-xs-12" style={{textAlign:'center'}}>
                                        <h3>Almacén</h3>
                                    </div>
                                    <div className="col-xs-12">
                                        <ResponsiveContainer width={$('.pie-graph').width() - 100} height={300}>
                                            <PieChart width={730} height={250}>
                                                <Pie 
                                                    data={this.state.units_by_component_type} 
                                                    dataKey="total" 
                                                    nameKey="component_type" 
                                                    cx="50%" 
                                                    cy="50%" 
                                                    outerRadius={100} 
                                                    fill="rgba(var(--primary))" 
                                                />
                                                {this.state.units_by_component_type.map((entry, i)=>{
                                                    setTimeout(()=>{
                                                        $('.recharts-sector').eq(i).attr('fill', this.state.colorArray[i % this.state.colorArray.length])
                                                    }, 850)
                                                })}
                                                <Tooltip />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>

                                    
                                </CardContent>
                            </Card>
                        }
                        
                    </div>
                    
                </div>
                
                    
                
            </div>
        )
    }
}

export default Graphics;